<template>
  <div>
    <v-layout class="banner"></v-layout>
    <v-container class="intro">
      <v-row>
        <v-col cols="12" sm="12" md="6" class="intro-img"></v-col>
        <v-col cols="12" sm="12" md="6" class="inner">
          <h5 class="title-sm">Riiqo Storage</h5>
          <h1>Drop, Box. Cause You Can Store With Us</h1>
          <router-link to="contact" class="btn">Get Started</router-link>
        </v-col>
      </v-row>
    </v-container>

    <div class="riiqosxn riiqosxn-bar">
      <h1 class="riiqosxn-title">Features</h1>
      <div class="mod-bar">
        <div class="mod-bar__line"></div>
        <div class="mod-bar__dot"></div>
      </div>
    </div>
   
    <div class="riiqosxn riiqosxn-search">
      <v-container>
        <v-row class="row-map">
          <v-col cols="12" sm="6" lg="5" class="riiqosxn-content">
            <h1>Search Files by Type</h1>
            <p>There are lots of ways to search storage, but to make it even easier you can also search with in a file type.</p>
            <div class="mod-row">
              <div class="mod-row__item"
                v-for="ft in fileTypes"
                :key="'so'+ft.name">
                <div class="mod-icon" :style="{ 'background-image': `url(/assets/images/storage/${ft.icon})` }"></div>
                {{ ft.name }}
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="6" lg="7" class="col-img">
            <div class="riiqosxn-img"></div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    
    <div class="riiqosxn riiqosxn-sharefile">
      <v-container>
        <v-row class="row-intro">
          <v-col cols="12" sm="6" md="7">
            <div class="riiqosxn-img"></div>
          </v-col>
          <v-col cols="12" sm="6" md="5" class="riiqosxn-content">
            <h1>Share Files <br>With Your Team</h1>
            <p>Add your employees to the files they need to access. Talk about it all you want with collaborative notes for each file.</p>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-edit-gdocs">
      <v-container>
        <h1>Edit Google Docs, Sheets, & Presentations Inside</h1>
        <div class="riiqosxn-content">
          <v-row>
              <v-col>
                <p>Now you can access your google drive in the same place you do all your other work. But why just look at it when you can edit it in the same place. Integrations with Google Drive allow you to edit those same files right from Riiqo.</p>    
              </v-col>
              <v-col>
                <p>Your files will be updated in real time so they are the same everywhere. Use all the same great features you expect from the Google products you love.</p>    
              </v-col>
            </v-row>
        </div>
      </v-container>
    </div>
    
    <div class="riiqosxn riiqosxn-gdocs">
      <v-container class="container-img">
        <div class="riiqosxn-img"></div>
      </v-container>
    </div>
    
    <div class="riiqosxn riiqosxn-history">
      <div class="riiqosxn-img"></div>
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" md="5" class="riiqosxn-content">
            <h1>Complete History for Accountability</h1>
            <p>Who’s doing what is really important? Now you don’t have to wonder because it’s recorded so now you’ll always know.</p>
          </v-col>
          <v-col cols="12" sm="6" md="7"></v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-data-tracked">
      <v-container>
        <h4 class="riiqosxn-title">History Data Tracked</h4>
        <v-row class="row-content">
          <v-col cols="6" class="col-left">
            <v-row class="mod-history-data">
              <v-col cols="12" sm="6" class="mod-history-data__item">
                <span class="icon _schedule_filled"></span>
                <h4>Date/Time</h4>
              </v-col>
              <v-col cols="12" sm="6" class="mod-history-data__item">
                <span class="icon _customermodule"></span>
                <h4>Changed By</h4>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" class="col-right">
            <v-row class="mod-history-data">
              <v-col cols="12" sm="6" class="mod-history-data__item">
                <span class="icon _interchangemodule"></span>
                <h4>Edit Type</h4>
              </v-col>
              <v-col cols="12" sm="6" class="mod-history-data__item">
                <span class="icon _leftaligned"></span>
                <h4>Details</h4>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <div class="mod-bar">
          <div class="mod-bar__line"></div>
          <div class="mod-bar__dot"></div>
        </div>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-your-files">
      <!-- <div class="trapezoid-bg"></div> -->
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" md="6" class="col-img">
            <div class="riiqosxn-img"></div>
          </v-col>
          <v-col cols="12" sm="6" md="6" class="riiqosxn-content">
            <h1>Use Your Files <br/>Throughout <br/>the Riiqo System</h1>
            <p>Because everything is integrated, you can add files or images right to a customer from storage. Access your files through the system.</p>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-plan">
      <!-- <div class="riiqosxn-bg"></div> -->
      <v-container>
        <v-row>
          <v-col cols="12" class="riiqosxn-content">
            <h1>Choose a Plan to Fit Your Needs</h1>
            <div class="mod-plans">
              <div class="mod-row">
                <div class="mod-row__item tengb">
                  <div class="item-inner">
                    <h1>10 GB</h1>
                    <h4 class="free">Free</h4>
                  </div>
                </div>
                <div class="mod-row__item hundredgb">
                  <div class="item-inner">
                    <h1>100 GB</h1>
                  </div>
                </div>
                <div class="mod-row__item onetb">
                  <div class="item-inner">
                    <h1>1 TB</h1>
                  </div>
                </div>
                <div class="mod-row__item threetb">
                  <div class="item-inner">
                    <h1>3 TB</h1>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-content">
              <p>Need more storage? Upgrade at anytime, and make sure you and your employees have access to all your files all the time and anywhere.</p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    
    <SxnCta />
  </div>
</template>

<script>
import { bus } from '../../../main'
import SxnCta from '../../commons/SxnCta'
export default {
  name: 'storage',
  components: { SxnCta },
  data: () => ({
    fileTypes: [
      { name: 'PDFs', icon: 'pdf-icon.png' },
      { name: 'Files', icon: 'files-icon.png' },
      { name: 'Sheets', icon: 'sheets-icon.png' },
      { name: 'Slideshows', icon: 'slideshow-icon.png' },
      { name: 'Images', icon: 'images-icon.png' },
      { name: 'Videos', icon: 'videos-icon.png' }
    ]
  }),
  mounted() {
		console.log(this.$route);
		bus.$emit('update-route', this.$route);
  }
};
</script>
